import { Drawer, type DrawerHeaderProps } from "../../shared/Drawer";
import { useNavigateWithQueryParams } from "../../shared/navigateWithQueryParams";

export const AssessmentDrawerHeader = (props: Omit<DrawerHeaderProps, "verticalPadding" | "onClose">) => {
  const navigate = useNavigateWithQueryParams();
  return <Drawer.Header {...props} verticalPadding={1.4} onClose={() => navigate("..")} />;
};
